export const InfluencerCodeGenerator = (name) =>{
    var seq = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
    const foutLatter = name.substring(0, 4).toUpperCase()
    return foutLatter+seq
}